import { Navigate } from "../../../../../router-utils"

export default function OrganizationTemplatesPage() {
	return <Navigate to="/org/tourists/all" replace />
}
